/**
 *
 * @param str String
 * @returns String
 */
const removeSpaces = (str) => str.replace(/\s+/g, '');

/**
 * @param str String
 * @returns String
 */
const removeNumbers = (str) => {
  return str.replace(/\D/g, '');
};

const removeSpecialCharacters = (str) => {
  return str.replace(/[^\w\s]/gi, '');
};

const removeCharacters = (str) => {
  return str.replace(/[a-zA-Z]/g, '');
};

const removeCharactersAndSpecialCharacters = (str) => {
  return str.replace(/[a-zA-Z]/g, '').replace(/[^\w\s]/gi, '');
};

export const RegexUtils = {
  removeSpaces,
  removeNumbers,
  removeCharacters,
  removeSpecialCharacters,
  removeCharactersAndSpecialCharacters
};
